import { useCallback, useState } from "react";

export interface AttachmentViewerState {
  /** Index of the attachment the in-app viewer is open on, or null when closed. */
  viewerIndex: number | null;
  /** Pass straight through to `AttachmentList`'s `onOpen`. */
  openViewer: (index: number) => void;
  /** Stable identity so effects keyed on it (e.g. `useEscapeKey`) don't churn. */
  closeViewer: () => void;
}

/**
 * Open/close state for the in-app `AttachmentViewer`, shared by the
 * task-level and subtask-level attachment sections so the wiring isn't
 * duplicated between them.
 */
export function useAttachmentViewer(): AttachmentViewerState {
  const [viewerIndex, setViewerIndex] = useState<number | null>(null);
  const closeViewer = useCallback(() => setViewerIndex(null), []);
  return { viewerIndex, openViewer: setViewerIndex, closeViewer };
}
